//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import Modals from '../../../modal';
/**@type {import('../types').DataType<import('./types').SubscriptionDataModel>} */

var SUBSCRIPTION_DATA_TYPE = {
  data: {
    url: '/backend/subscriptions',
    deleteItemUrl: '/backend/subscriptions/{id}',
    dataKey: 'subscriptions',
    idKeyProp: 'Id'
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        text: data.Name,
        component: "a",
        onClick: function onClick() {
          return Modals.open({
            type: Modals.TYPES.MANAGE_SUBSCRIPTION,
            props: {
              id: data.Id
            }
          });
        }
      });
    },
    serverSort: true
  }, {
    id: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    },
    serverSort: false,
    inMemorySort: false
  }],
  placeholders: {
    type: function type() {
      return 'subscription';
    },
    label: function label(data) {
      return data.Name;
    }
  },
  thumbnail: {
    text: function text(data) {
      return data.Name;
    },
    icon: function icon() {
      return 'subscription';
    }
  },
  contextMenu: [{
    type: 'delete'
  }, 'separator', {
    label: 'Properties',
    onClick: function onClick(e, data) {
      return Modals.open({
        type: Modals.TYPES.MANAGE_SUBSCRIPTION,
        props: {
          id: data.Id
        }
      });
    }
  }]
};
export default SUBSCRIPTION_DATA_TYPE;